export const options = [
    {
        id: 0,
        value: 'series',
        title: 'Séries',
        parameter: 'titleStartsWith',
    },
    {
        id: 1,
        value: 'stories',
        title: 'Histórias',
        parameter: 'titleStartsWith',
    },
    {
        id: 2,
        value: 'creators',
        title: 'Criadores',
        parameter: 'nameStartsWith',
        default: true,
    },
    {
        id: 3,
        value: 'comics',
        title: 'Quadrinhos',
        parameter: 'titleStartsWith',
    },
    {
        id: 4,
        value: 'events',
        title: 'Eventos',
        parameter: 'nameStartsWith',
    },
];
